import { RefObject, useEffect } from 'react';

type UseClickOutsideOptions = {
  ref: RefObject<HTMLElement>;
  elementId?: string;
  onClickOutside: () => void;
  enabled: boolean;
};

export default function useClickOutside({ ref, elementId, onClickOutside, enabled }: UseClickOutsideOptions) {
  useEffect(() => {
    if (!enabled) return;

    function handleClickOutside(event: MouseEvent) {
      const target = event.target as Node;

      if (ref.current?.contains(target)) return;

      if (elementId) {
        const element = document.getElementById(elementId);
        if (element?.contains(target)) return;
      }
      onClickOutside();
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, elementId, onClickOutside, enabled]);
}
